<template>
  <div class="uk-container">
    <div class="uk-card uk-card-default uk-width-large uk-margin-auto">
      <div class="uk-card-header uk-text-center">
        <h3 class="uk-card-title">Support Ticket</h3>
        <p class="uk-text-meta">Create a new support ticket if you encounter an issue with the application. <span uk-tooltip="This ticket will be automatically submitted to our support team which will try to get back to you as soon as possible."><i class="icon gg-info" /></span></p>
      </div>
      <div class="uk-card-body">
        <ValidationObserver ref="observer-ticket" tag="div" class="uk-form-stacked">
          <div class="uk-margin">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <label class="uk-form-label uk-text-bold" for="name" :class="{ 'uk-text-danger': errors.length }">Name</label>
              <div class="uk-form-controls">
                <input id="name" v-model="name" class="uk-input" :class="{ 'uk-form-danger': errors.length }" type="text" name="name">
              </div>
              <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>

          <div class="uk-margin">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <label class="uk-form-label uk-text-bold" for="email" :class="{ 'uk-text-danger': errors.length }">Email</label>
              <div class="uk-form-controls">
                <input id="email" v-model="email" class="uk-input" :class="{ 'uk-form-danger': errors.length }" type="text" name="email">
              </div>
              <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>

          <div class="uk-margin">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <label class="uk-form-label uk-text-bold" for="description" :class="{ 'uk-text-danger': errors.length }">Description</label>
              <div class="uk-form-controls">
                <textarea id="description" v-model="description" class="uk-textarea" :class="{ 'uk-form-danger': errors.length }" type="text" name="description" rows="7" />
              </div>
              <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
        </ValidationObserver>
      </div>
      <div class="uk-card-footer uk-text-center">
        <button class="uk-button uk-button-primary" @click="submit">Submit Ticket</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  name: 'ViewTicketCreate',

  components: {
    ValidationProvider,
    ValidationObserver
  },


  data() {
    return {
      name: null,
      email: null,
      description: null
    }
  },

  computed: {
    profile() {
      return this.$store.state.account.profile
    }
  },

  mounted() {
    this.name = `${this.profile.name.first} ${this.profile.name.last}`
    this.email = this.profile.email
  },

  methods: {
    async submit() {
      const isValid = await this.$refs['observer-ticket'].validate()

      if (isValid) {
        const ticket = {
          content: {
            name: this.name,
            email: this.email,
            description: this.description
          },
          info: {
            status: 'new',
            created: {
              timestamp: this.$firebase.firestore.FieldValue.serverTimestamp(),
              user: this.$store.state.account.record.uid
            }
          },
          log: this.$firebase.firestore.FieldValue.arrayUnion({
            timestamp: this.$firebase.firestore.Timestamp.now(),
            user: this.$store.state.account.record.uid,
            type: 'create'
          })
        }

        try {
          await this.$firebase.firestore().collection(this.$globals.firebase.collection.tickets).add(ticket)
          this.$uikit.notification('Your ticket was submitted successfully!', 'success')

          this.name = null
          this.email = null
          this.description = null

          this.$refs['observer-ticket'].reset()
        } catch (error) {
          console.log(error)
          this.$uikit.notification('Something went wrong while submitting your ticket. Please try again later, or use different support method.', 'danger')
        }
      }
    }
  }
}
</script>
